export default "__VITE_PUBLIC_ASSET__1bfa5994__"